<template>
  <textarea
    ref="textareaRef"
    v-model="draft"
    class="block w-full resize-none overflow-hidden rounded border border-gray-400 bg-yellow-100 p-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-400"
    @input="onInput"
    @blur="emit('blurred', $event.relatedTarget)"
  />
</template>

<script setup lang="ts">
import { nextTick, onMounted, ref, watch } from 'vue'
import { toEditableText, fromEditableText } from './editable_wiki_text'

const props = defineProps<{
  text: string
}>()

const emit = defineEmits<{
  draft: [plainText: string, wikiText: string]
  blurred: [relatedTarget: EventTarget | null]
}>()

const textareaRef = ref<HTMLTextAreaElement | null>(null)
const draft = ref(toEditableText(props.text))

watch(() => props.text, text => {
  draft.value = toEditableText(text)
  nextTick(fitToContent)
})

const fitToContent = () => {
  const textarea = textareaRef.value
  if (!textarea) return
  textarea.style.height = 'auto'
  textarea.style.height = `${textarea.scrollHeight}px`
}

const onInput = () => {
  fitToContent()
  emit('draft', draft.value, fromEditableText(draft.value, props.text))
}

onMounted(() => {
  fitToContent()
  textareaRef.value?.focus()
})
</script>
